 import { authenticationService } from './services/authenticationService.js';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/app_body/header.jsx';
import Body from './components/app_body/body.jsx';
import { createBrowserHistory } from 'history';
import MediaQuery from 'react-responsive';
import React, { useEffect, useState } from 'react';
import ReactDom from 'react-dom';
import { PopupService } from './services/popup_service.jsx';
import { tankLevelNotificationScheduler } from './services/tanks_level_notification_scheduler.js';
import { createStructuredSelector } from 'reselect';
import { selectAppUser } from './state/selectors/app.js';
import { connect } from 'react-redux';
 
export const history = createBrowserHistory();

const mapStateToProps = () => {
    return createStructuredSelector({
        currentUser: selectAppUser()
    });
};

const App = (props) => {
    const {currentUser} = props;

	const setNewPopup = (newPopup) => {
        ReactDom.render(newPopup, document.getElementById('popups'));
    }
 
    useEffect(() => {
        const subscription = PopupService.popup.subscribe(setNewPopup);
        return () => subscription.unsubscribe();
    }, []);

     useEffect(() => {
         tankLevelNotificationScheduler.start();
         return () => tankLevelNotificationScheduler.stop();
     }, []);
 
     return (
         <Router history={history}>
             <div>
                 <MediaQuery minDeviceWidth={1224}>
                     <div>
                         {currentUser && <Header />}
                         <Body/>
                         <div id='popups'></div>
                     </div>
                 </MediaQuery>
                 <MediaQuery maxDeviceWidth={1224}>
                     <div className="mobile_view">
                         {currentUser && <Header />}
                         <Body/>
                         <div id='popups'></div>
                     </div>
                 </MediaQuery>
             </div>
         </Router>
     );
 }

 export default connect(mapStateToProps)(App);